export default __webpack_public_path__ + "static/media/dummy.ca8ce0e2.pdf";